/**
 * The mark beside an unread row — the bell, the notification inbox, messages.
 *
 * **A dot, not bold text.** Bold on half a list makes the read half look
 * disabled rather than merely older. A read row keeps the dot's space,
 * transparent, so the text does not shift when it is read.
 */
import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';

export interface UnreadDotProps {
  unread: boolean;
  /** Placement only — e.g. a top margin to sit on a first line of text. */
  sx?: SxProps<Theme>;
}

export function UnreadDot({ unread, sx }: UnreadDotProps) {
  return (
    <Box
      sx={[
        {
          width: 8,
          height: 8,
          borderRadius: '50%',
          flexShrink: 0,
          bgcolor: unread ? 'primary.main' : 'transparent',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
}
